import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "SolidCloud International | Advanced Aerogel Materials",
  description = "Advanced aerogel solutions engineered for thermal protection, energy systems, and high-performance industrial applications. Leading innovation in lightweight performance materials.",
  keywords = "aerogel, thermal insulation, lightweight materials, EV battery safety, industrial insulation, aerospace materials, thermal management, energy efficiency",
  image = "https://customer-assets.emergentagent.com/job_5e64245c-1d1f-4436-8cfb-bf9096ddb29a/artifacts/or26avje_WhatsApp%20Image%202026-01-31%20at%2021.10.19.jpeg",
  url = typeof window !== 'undefined' ? window.location.href : '',
  type = "website"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="SolidCloud International" />
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEOHead;
